// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file crm/v1/account_individual_details.proto (package crm.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { AccountIdentityDocument } from "./account_identity_document_pb.js";
import { file_crm_v1_account_identity_document } from "./account_identity_document_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file crm/v1/account_individual_details.proto.
 */
export const file_crm_v1_account_individual_details: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_types, file_crm_v1_account_identity_document]);

/**
 * AccountIndividualDetails message definition
 *
 * @generated from message crm.v1.AccountIndividualDetails
 */
export type AccountIndividualDetails = Message<"crm.v1.AccountIndividualDetails"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID account_id = 2;
   */
  accountId?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp date_of_birth = 3;
   */
  dateOfBirth?: Timestamp;

  /**
   * @generated from field: crm.v1.IndividualSex sex = 4;
   */
  sex: IndividualSex;

  /**
   * @generated from field: int32 height = 5;
   */
  height: number;

  /**
   * @generated from field: int32 weight = 6;
   */
  weight: number;

  /**
   * @generated from field: crm.v1.IndividualRace race = 7;
   */
  race: IndividualRace;

  /**
   * @generated from field: crm.v1.IndividualEyeColor eye_color = 8;
   */
  eyeColor: IndividualEyeColor;

  /**
   * @generated from field: crm.v1.IndividualHairColor hair_color = 9;
   */
  hairColor: IndividualHairColor;

  /**
   * @generated from field: string employer = 10;
   */
  employer: string;

  /**
   * @generated from field: types.Base base = 11;
   */
  base?: Base;

  /**
   * @generated from field: repeated crm.v1.AccountIdentityDocument identity_documents = 12;
   */
  identityDocuments: AccountIdentityDocument[];
};

/**
 * Describes the message crm.v1.AccountIndividualDetails.
 * Use `create(AccountIndividualDetailsSchema)` to create a new message.
 */
export const AccountIndividualDetailsSchema: GenMessage<AccountIndividualDetails> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_individual_details, 0);

/**
 * Request/Response messages for AccountIndividualDetails queries
 *
 * @generated from message crm.v1.GetAccountIndividualDetailsRequest
 */
export type GetAccountIndividualDetailsRequest = Message<"crm.v1.GetAccountIndividualDetailsRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.GetAccountIndividualDetailsRequest.
 * Use `create(GetAccountIndividualDetailsRequestSchema)` to create a new message.
 */
export const GetAccountIndividualDetailsRequestSchema: GenMessage<GetAccountIndividualDetailsRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_individual_details, 1);

/**
 * @generated from message crm.v1.GetAccountIndividualDetailsResponse
 */
export type GetAccountIndividualDetailsResponse = Message<"crm.v1.GetAccountIndividualDetailsResponse"> & {
  /**
   * @generated from field: crm.v1.AccountIndividualDetails account_individual_details = 1;
   */
  accountIndividualDetails?: AccountIndividualDetails;
};

/**
 * Describes the message crm.v1.GetAccountIndividualDetailsResponse.
 * Use `create(GetAccountIndividualDetailsResponseSchema)` to create a new message.
 */
export const GetAccountIndividualDetailsResponseSchema: GenMessage<GetAccountIndividualDetailsResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_individual_details, 2);

/**
 * @generated from message crm.v1.ListAccountIndividualDetailsesRequest
 */
export type ListAccountIndividualDetailsesRequest = Message<"crm.v1.ListAccountIndividualDetailsesRequest"> & {
  /**
   * @generated from field: crm.v1.ListAccountIndividualDetailsesFilter filter = 1;
   */
  filter?: ListAccountIndividualDetailsesFilter;

  /**
   * @generated from field: repeated crm.v1.AccountIndividualDetailsSortOption sorting = 2;
   */
  sorting: AccountIndividualDetailsSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message crm.v1.ListAccountIndividualDetailsesRequest.
 * Use `create(ListAccountIndividualDetailsesRequestSchema)` to create a new message.
 */
export const ListAccountIndividualDetailsesRequestSchema: GenMessage<ListAccountIndividualDetailsesRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_individual_details, 3);

/**
 * @generated from message crm.v1.ListAccountIndividualDetailsesFilter
 */
export type ListAccountIndividualDetailsesFilter = Message<"crm.v1.ListAccountIndividualDetailsesFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue search_term = 2;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.ListAccountIndividualDetailsesFilter.
 * Use `create(ListAccountIndividualDetailsesFilterSchema)` to create a new message.
 */
export const ListAccountIndividualDetailsesFilterSchema: GenMessage<ListAccountIndividualDetailsesFilter> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_individual_details, 4);

/**
 * @generated from message crm.v1.ListAccountIndividualDetailsesResponse
 */
export type ListAccountIndividualDetailsesResponse = Message<"crm.v1.ListAccountIndividualDetailsesResponse"> & {
  /**
   * @generated from field: repeated crm.v1.AccountIndividualDetails account_individual_detailses = 1;
   */
  accountIndividualDetailses: AccountIndividualDetails[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message crm.v1.ListAccountIndividualDetailsesResponse.
 * Use `create(ListAccountIndividualDetailsesResponseSchema)` to create a new message.
 */
export const ListAccountIndividualDetailsesResponseSchema: GenMessage<ListAccountIndividualDetailsesResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_individual_details, 5);

/**
 * Input messages
 *
 * @generated from message crm.v1.AccountIndividualDetailsInput
 */
export type AccountIndividualDetailsInput = Message<"crm.v1.AccountIndividualDetailsInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID account_id = 2;
   */
  accountId?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp date_of_birth = 3;
   */
  dateOfBirth?: Timestamp;

  /**
   * @generated from field: crm.v1.IndividualSex sex = 4;
   */
  sex: IndividualSex;

  /**
   * @generated from field: int32 height = 5;
   */
  height: number;

  /**
   * @generated from field: int32 weight = 6;
   */
  weight: number;

  /**
   * @generated from field: crm.v1.IndividualRace race = 7;
   */
  race: IndividualRace;

  /**
   * @generated from field: crm.v1.IndividualEyeColor eye_color = 8;
   */
  eyeColor: IndividualEyeColor;

  /**
   * @generated from field: crm.v1.IndividualHairColor hair_color = 9;
   */
  hairColor: IndividualHairColor;

  /**
   * @generated from field: string employer = 10;
   */
  employer: string;
};

/**
 * Describes the message crm.v1.AccountIndividualDetailsInput.
 * Use `create(AccountIndividualDetailsInputSchema)` to create a new message.
 */
export const AccountIndividualDetailsInputSchema: GenMessage<AccountIndividualDetailsInput> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_individual_details, 6);

/**
 * @generated from message crm.v1.AccountIndividualDetailsUpdateInput
 */
export type AccountIndividualDetailsUpdateInput = Message<"crm.v1.AccountIndividualDetailsUpdateInput"> & {
  /**
   * @generated from field: google.protobuf.Timestamp date_of_birth = 1;
   */
  dateOfBirth?: Timestamp;

  /**
   * @generated from field: crm.v1.IndividualSex sex = 2;
   */
  sex: IndividualSex;

  /**
   * @generated from field: google.protobuf.Int32Value height = 3;
   */
  height?: number;

  /**
   * @generated from field: google.protobuf.Int32Value weight = 4;
   */
  weight?: number;

  /**
   * @generated from field: crm.v1.IndividualRace race = 5;
   */
  race: IndividualRace;

  /**
   * @generated from field: crm.v1.IndividualEyeColor eye_color = 6;
   */
  eyeColor: IndividualEyeColor;

  /**
   * @generated from field: crm.v1.IndividualHairColor hair_color = 7;
   */
  hairColor: IndividualHairColor;

  /**
   * @generated from field: google.protobuf.StringValue employer = 8;
   */
  employer?: string;
};

/**
 * Describes the message crm.v1.AccountIndividualDetailsUpdateInput.
 * Use `create(AccountIndividualDetailsUpdateInputSchema)` to create a new message.
 */
export const AccountIndividualDetailsUpdateInputSchema: GenMessage<AccountIndividualDetailsUpdateInput> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_individual_details, 7);

/**
 * IndividualSex enum
 *
 * @generated from enum crm.v1.IndividualSex
 */
export enum IndividualSex {
  /**
   * @generated from enum value: INDIVIDUAL_SEX_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INDIVIDUAL_SEX_MALE = 1;
   */
  MALE = 1,

  /**
   * @generated from enum value: INDIVIDUAL_SEX_FEMALE = 2;
   */
  FEMALE = 2,
}

/**
 * Describes the enum crm.v1.IndividualSex.
 */
export const IndividualSexSchema: GenEnum<IndividualSex> = /*@__PURE__*/
  enumDesc(file_crm_v1_account_individual_details, 0);

/**
 * IndividualRace enum
 *
 * @generated from enum crm.v1.IndividualRace
 */
export enum IndividualRace {
  /**
   * @generated from enum value: INDIVIDUAL_RACE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INDIVIDUAL_RACE_AMERICAN_INDIAN = 1;
   */
  AMERICAN_INDIAN = 1,

  /**
   * @generated from enum value: INDIVIDUAL_RACE_ASIAN = 2;
   */
  ASIAN = 2,

  /**
   * @generated from enum value: INDIVIDUAL_RACE_BLACK = 3;
   */
  BLACK = 3,

  /**
   * @generated from enum value: INDIVIDUAL_RACE_HISPANIC = 4;
   */
  HISPANIC = 4,

  /**
   * @generated from enum value: INDIVIDUAL_RACE_WHITE = 5;
   */
  WHITE = 5,

  /**
   * @generated from enum value: INDIVIDUAL_RACE_UNKNOWN = 6;
   */
  UNKNOWN = 6,
}

/**
 * Describes the enum crm.v1.IndividualRace.
 */
export const IndividualRaceSchema: GenEnum<IndividualRace> = /*@__PURE__*/
  enumDesc(file_crm_v1_account_individual_details, 1);

/**
 * IndividualEyeColor enum
 *
 * @generated from enum crm.v1.IndividualEyeColor
 */
export enum IndividualEyeColor {
  /**
   * @generated from enum value: INDIVIDUAL_EYE_COLOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INDIVIDUAL_EYE_COLOR_BLACK = 1;
   */
  BLACK = 1,

  /**
   * @generated from enum value: INDIVIDUAL_EYE_COLOR_BLUE = 2;
   */
  BLUE = 2,

  /**
   * @generated from enum value: INDIVIDUAL_EYE_COLOR_BROWN = 3;
   */
  BROWN = 3,

  /**
   * @generated from enum value: INDIVIDUAL_EYE_COLOR_GRAY = 4;
   */
  GRAY = 4,

  /**
   * @generated from enum value: INDIVIDUAL_EYE_COLOR_GREEN = 5;
   */
  GREEN = 5,

  /**
   * @generated from enum value: INDIVIDUAL_EYE_COLOR_HAZEL = 6;
   */
  HAZEL = 6,

  /**
   * @generated from enum value: INDIVIDUAL_EYE_COLOR_MAROON = 7;
   */
  MAROON = 7,

  /**
   * @generated from enum value: INDIVIDUAL_EYE_COLOR_MULTICOLORED = 8;
   */
  MULTICOLORED = 8,

  /**
   * @generated from enum value: INDIVIDUAL_EYE_COLOR_PINK = 9;
   */
  PINK = 9,

  /**
   * @generated from enum value: INDIVIDUAL_EYE_COLOR_UNKNOWN = 10;
   */
  UNKNOWN = 10,
}

/**
 * Describes the enum crm.v1.IndividualEyeColor.
 */
export const IndividualEyeColorSchema: GenEnum<IndividualEyeColor> = /*@__PURE__*/
  enumDesc(file_crm_v1_account_individual_details, 2);

/**
 * IndividualHairColor enum
 *
 * @generated from enum crm.v1.IndividualHairColor
 */
export enum IndividualHairColor {
  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_BALD = 1;
   */
  BALD = 1,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_BLACK = 2;
   */
  BLACK = 2,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_BLOND = 3;
   */
  BLOND = 3,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_BROWN = 4;
   */
  BROWN = 4,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_GRAY = 5;
   */
  GRAY = 5,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_GREEN = 6;
   */
  GREEN = 6,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_ORANGE = 7;
   */
  ORANGE = 7,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_PINK = 8;
   */
  PINK = 8,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_PURPLE = 9;
   */
  PURPLE = 9,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_RED = 10;
   */
  RED = 10,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_SANDY = 11;
   */
  SANDY = 11,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_WHITE = 12;
   */
  WHITE = 12,

  /**
   * @generated from enum value: INDIVIDUAL_HAIR_COLOR_UNKNOWN = 13;
   */
  UNKNOWN = 13,
}

/**
 * Describes the enum crm.v1.IndividualHairColor.
 */
export const IndividualHairColorSchema: GenEnum<IndividualHairColor> = /*@__PURE__*/
  enumDesc(file_crm_v1_account_individual_details, 3);

/**
 * @generated from enum crm.v1.AccountIndividualDetailsSortOption
 */
export enum AccountIndividualDetailsSortOption {
  /**
   * @generated from enum value: ACCOUNT_INDIVIDUAL_DETAILS_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCOUNT_INDIVIDUAL_DETAILS_SORT_OPTION_CREATED_AT_ASC = 1;
   */
  CREATED_AT_ASC = 1,

  /**
   * @generated from enum value: ACCOUNT_INDIVIDUAL_DETAILS_SORT_OPTION_CREATED_AT_DESC = 2;
   */
  CREATED_AT_DESC = 2,

  /**
   * @generated from enum value: ACCOUNT_INDIVIDUAL_DETAILS_SORT_OPTION_UPDATED_AT_ASC = 3;
   */
  UPDATED_AT_ASC = 3,

  /**
   * @generated from enum value: ACCOUNT_INDIVIDUAL_DETAILS_SORT_OPTION_UPDATED_AT_DESC = 4;
   */
  UPDATED_AT_DESC = 4,
}

/**
 * Describes the enum crm.v1.AccountIndividualDetailsSortOption.
 */
export const AccountIndividualDetailsSortOptionSchema: GenEnum<AccountIndividualDetailsSortOption> = /*@__PURE__*/
  enumDesc(file_crm_v1_account_individual_details, 4);

/**
 * Services
 *
 * @generated from service crm.v1.AccountIndividualDetailsQueriesService
 */
export const AccountIndividualDetailsQueriesService: GenService<{
}> = /*@__PURE__*/
  serviceDesc(file_crm_v1_account_individual_details, 0);

/**
 * @generated from service crm.v1.AccountIndividualDetailsCommandsService
 */
export const AccountIndividualDetailsCommandsService: GenService<{
}> = /*@__PURE__*/
  serviceDesc(file_crm_v1_account_individual_details, 1);

